// Mock data for Marvin's Contracting portfolio

export const translations = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      portfolio: 'Portfolio',
      about: 'About Us',
      contact: 'Contact'
    },
    hero: {
      title: "Marvin's Contracting",
      subtitle: 'Quality Craftsmanship You Can Trust',
      cta: 'Get Free Estimate',
      licensed: 'Licensed & Insured'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Professional construction services tailored to your needs',
      items: [
        {
          id: 1,
          name: 'Kitchen Remodeling',
          description: 'Transform your kitchen into a beautiful and functional space with our expert remodeling services.'
        },
        {
          id: 2,
          name: 'Bathroom Renovation',
          description: 'Upgrade your bathroom with modern fixtures, tiles, and designs that add value to your home.'
        },
        {
          id: 3,
          name: 'Flooring',
          description: 'Expert installation of hardwood, tile, laminate, and vinyl flooring for any room in your home.'
        },
        {
          id: 4,
          name: 'Painting',
          description: 'Professional interior and exterior painting services to refresh and protect your property.'
        }
      ]
    },
    portfolio: {
      title: 'Our Work',
      subtitle: 'View Our Work',
      viewAll: 'Click to view full size'
    },
    about: {
      title: 'About Us',
      subtitle: 'Your trusted partner in construction',
      intro: 'We\'re a locally owned and operated contracting business built on one simple belief: do the job right the first time.',
      paragraph1: 'With years of hands-on experience, we specialize in delivering high-quality craftsmanship, honest communication, and dependable service. Whether it\'s a small repair or a full renovation, we treat every home like it\'s our own, with care, respect, and attention to detail.',
      paragraph2: 'Our reputation has grown through word of mouth, repeat customers, and neighbors who trust us. We show up when we say we will. We keep our job sites clean. And we don\'t consider a project complete until you\'re satisfied.',
      focusTitle: 'From planning to completion, we focus on:',
      focusPoints: [
        'Clear timelines',
        'Fair pricing',
        'Quality materials',
        'Skilled workmanship'
      ],
      closing: 'We understand that inviting someone to work on your home is a big decision. That\'s why we prioritize transparency, reliability, and results you can be proud of.',
      finalNote: 'If you\'re looking for a contractor who values integrity and stands behind their work, we\'d be honored to earn your trust.'
    },
    contact: {
      title: 'Get In Touch',
      subtitle: 'Free Estimates',
      form: {
        name: 'Your Name',
        email: 'Email Address',
        phone: 'Phone Number',
        message: 'Tell us about your project',
        submit: 'Send Message'
      },
      success: 'Thank you! We\'ll contact you soon.'
    },
    footer: {
      rights: 'All rights reserved',
      tagline: 'Quality Craftsmanship Since 2020'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      portfolio: 'Portafolio',
      about: 'Nosotros',
      contact: 'Contacto'
    },
    hero: {
      title: "Marvin's Contracting",
      subtitle: 'Artesanía de Calidad en la que Puede Confiar',
      cta: 'Presupuestos Gratuitos',
      licensed: 'Licenciado y Asegurado'
    },
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Servicios de construcción profesionales adaptados a sus necesidades',
      items: [
        {
          id: 1,
          name: 'Remodelación de Cocinas',
          description: 'Transforme su cocina en un espacio hermoso y funcional con nuestros servicios expertos de remodelación.'
        },
        {
          id: 2,
          name: 'Renovación de Baños',
          description: 'Actualice su baño con accesorios, azulejos y diseños modernos que agregan valor a su hogar.'
        },
        {
          id: 3,
          name: 'Pisos',
          description: 'Instalación experta de pisos de madera, azulejo, laminado y vinilo para cualquier habitación de su hogar.'
        },
        {
          id: 4,
          name: 'Pintura',
          description: 'Servicios profesionales de pintura interior y exterior para refrescar y proteger su propiedad.'
        }
      ]
    },
    portfolio: {
      title: 'Nuestro Trabajo',
      subtitle: 'Ver Nuestro Trabajo',
      viewAll: 'Haga clic para ver tamaño completo'
    },
    about: {
      title: 'Sobre Nosotros',
      subtitle: 'Su socio de confianza en construcción',
      intro: 'Somos una empresa de contratación de propiedad y operación local construida sobre una creencia simple: hacer el trabajo bien la primera vez.',
      paragraph1: 'Con años de experiencia práctica, nos especializamos en ofrecer artesanía de alta calidad, comunicación honesta y servicio confiable. Ya sea una pequeña reparación o una renovación completa, tratamos cada hogar como si fuera nuestro, con cuidado, respeto y atención al detalle.',
      paragraph2: 'Nuestra reputación ha crecido a través del boca a boca, clientes habituales y vecinos que confían en nosotros. Aparecemos cuando decimos que lo haremos. Mantenemos nuestros sitios de trabajo limpios. Y no consideramos un proyecto completo hasta que usted esté satisfecho.',
      focusTitle: 'Desde la planificación hasta la finalización, nos enfocamos en:',
      focusPoints: [
        'Plazos claros',
        'Precios justos',
        'Materiales de calidad',
        'Mano de obra calificada'
      ],
      closing: 'Entendemos que invitar a alguien a trabajar en su hogar es una gran decisión. Por eso priorizamos la transparencia, la confiabilidad y los resultados de los que puede estar orgulloso.',
      finalNote: 'Si está buscando un contratista que valore la integridad y respalde su trabajo, sería un honor ganar su confianza.'
    },
    contact: {
      title: 'Contáctenos',
      subtitle: 'Presupuestos Gratuitos',
      form: {
        name: 'Su Nombre',
        email: 'Correo Electrónico',
        phone: 'Número de Teléfono',
        message: 'Cuéntenos sobre su proyecto',
        submit: 'Enviar Mensaje'
      },
      success: '¡Gracias! Nos pondremos en contacto pronto.'
    },
    footer: {
      rights: 'Todos los derechos reservados',
      tagline: 'Artesanía de Calidad Desde 2020'
    }
  }
};

// Marvin's actual work photos - categorized by service type
const kitchenImages = [
  "FB_IMG_1704681945343.JPG", "FB_IMG_1772312454150.JPG", "FB_IMG_1772312664284.JPG",
  "FB_IMG_1772312803305.JPG", "FB_IMG_1772312809422.JPG", "FB_IMG_1772312890792.JPG",
  "FB_IMG_1772312900616.JPG", "FB_IMG_1772312921552.JPG", "FB_IMG_1772313015765.JPG",
  "Resized_20241121_174316.JPEG", "Resized_20250718_091900.JPEG", "Resized_20260227_163630.JPEG"
];

const bathroomImages = [
  "FB_IMG_1772312397483.JPG", "FB_IMG_1772312404253.JPG", "FB_IMG_1772312424140.JPG",
  "FB_IMG_1772312429877.JPG", "FB_IMG_1772312544046.JPG", "FB_IMG_1772312557480.JPG",
  "FB_IMG_1772312566473.JPG", "FB_IMG_1772312591731.JPG", "FB_IMG_1772312638258.JPG",
  "FB_IMG_1772312731235.JPG", "FB_IMG_1772312759311.JPG", "FB_IMG_1772312770743.JPG",
  "FB_IMG_1772312849677.JPG", "FB_IMG_1772312853264.JPG", "FB_IMG_1772312859989.JPG",
  "FB_IMG_1772312864303.JPG", "FB_IMG_1772312870222.JPG", "FB_IMG_1772312883598.JPG",
  "FB_IMG_1772312887790.JPG", "FB_IMG_1772312897981.JPG", "FB_IMG_1772312934586.JPG",
  "FB_IMG_1772312941558.JPG", "FB_IMG_1772312955937.JPG", "FB_IMG_1772313045982.JPG",
  "Resized_20231103_160554.JPEG", "Resized_20241112_191053.JPEG", "Resized_20241121_174319.JPEG",
  "Resized_20241121_174319 2.JPEG", "Resized_20241121_174322.JPEG", "Resized_20250312_132015.JPEG",
  "Resized_20251119_170928.JPEG", "Resized_FB_IMG_1772312788195.JPEG"
];

const flooringImages = [
  "FB_IMG_1772312500865.JPG", "FB_IMG_1772312600221.JPG", "FB_IMG_1772312618114.JPG",
  "FB_IMG_1772312627998.JPG", "FB_IMG_1772312657762.JPG", "FB_IMG_1772312749659.JPG",
  "FB_IMG_1772312952304.JPG", "FB_IMG_1772312966722.JPG", "Resized_20231112_131423.JPEG",
  "Resized_20241112_190908.JPEG", "Resized_20241121_173258.JPEG", "Resized_20241125_172118.JPEG",
  "Resized_20241125_172134.JPEG", "Resized_20250312_131534.JPEG", "Resized_20250430_134100.JPEG",
  "Resized_20250718_091121.JPEG", "Resized_20251119_160958.JPEG", "Resized_20251221_151247.JPEG",
  "Resized_20251221_151252.JPEG", "Resized_20260115_142231.JPEG", "Resized_20260115_142256.JPEG"
];

const paintingImages = [
  "FB_IMG_1704681957047.JPG", "FB_IMG_1772312677184 2.JPG", "FB_IMG_1772312693586.JPG",
  "FB_IMG_1772312710250.JPG", "FB_IMG_1772312949226.JPG", "Resized_20240919_151128.JPEG",
  "Resized_20250718_091853.JPEG", "Resized_20250827_150451.JPEG", "Resized_20260227_163616.JPEG",
  "Resized_20260227_163638.JPEG", "Resized_FB_IMG_1772312791238.JPEG"
];

// Import blur placeholders
import cloudinaryGallery from '../cloudinary-gallery.json';

// Export gallery from Cloudinary
export const galleryImages = cloudinaryGallery;